module.exports = __webpack_public_path__ + "f7d4abbc.png";